import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export default function RoleRoute({ roles = [] }) {
  const role =
    (window.__auth && window.__auth.user && window.__auth.user.role) ||
    localStorage.getItem("role");

  if (!role) return <Navigate to="/login" replace />;
  return roles.includes(String(role)) ? <Outlet /> : <Navigate to={`/${role}`} replace />;
}
